import {primaryColor, linkHoverFocusTextColor} from "../../../../style.scss"

 const confirmationDialog ={
      dialogContent: {
            float: 'left',
            width: '100%',
            padding: '20px',
            boxSizing: 'border-box',
          },
          actionContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            margin: '20px 0 0 0',
          },
          linkColor: {
            color: primaryColor,
            fontWeight: '600',
            cursor: 'pointer',
            '&:hover': {
              color: linkHoverFocusTextColor,
            },
            '&:focus': {
              color: linkHoverFocusTextColor,
            }
          },
}
export default confirmationDialog